import { render, staticRenderFns } from "./optads.vue?vue&type=template&id=3eac70f2&scoped=true&"
import script from "./optads.vue?vue&type=script&lang=js&"
export * from "./optads.vue?vue&type=script&lang=js&"
import style0 from "./optads.vue?vue&type=style&index=0&id=3eac70f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eac70f2",
  null
  
)

export default component.exports